import React, { useEffect, useState } from "react";
import "./shareholdingPattern.scss";
import {
  finanQu2File7,
  investDwnIcon,
  InvestorBgImg,
  InvestorFgImg,
  investPdfIcon,
  investUpArrow,
  textilesProspectus,
} from "../../images";
import { Link } from "react-router-dom";
import Dash from "../../components/Dash/Dash";
import InvestTab from "../../components/InvestTab/InvestTab";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import FinanceAcc from "../../components/FinanceAcc/FinanceAcc";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
import Stock from "../../components/StockIndicator/Stock";

const tabTopData = [
  {
    id: 1,
    title: "Corporate Governance",
    link: "/investor-relations/corporate-governance#corporate",
  },
  {
    id: 2,
    title: "Financial Performance & Presentation",
    link: "/investor-relations/financial-performance#financial",
  },
   // {
  //   id: 3,
  //   title: "Annual Reports",
  //   link: "/investor-relations/annual-reports#annual",
  // },
  {
    id: 4,
    title: "Announcements",
    link: "/investor-relations/announcements#announcement",
  },
  {
    id: 5,
    title: "Shareholding Pattern",
    link: "/investor-relations/shareholding-pattern#shareholding",
  },
];

const tabBottomData = [
  {
    id: 6,
    title: "Intimation of Investor Meet",
    link: "/investor-relations/investor-meet-presentation#intimation",
  },
  {
    id: 7,
    title: "Investor Contacts",
    link: "/investor-relations/investor-contacts#investor",
  },
  {
    id: 8,
    title:
      "Disclosures under Regulation 46 and 62 of SEBI (LODR) Regulations, 2015",
    link: "/investor-relations/disclosures-under-regulation-46-and-62-of-sebi-lodr-regulations-2015#disclosure",
  },
];

const intimationOfInvestorMeetData = [
  {
    id: 1,
    mainTitle: "Sanathan Textiles Limited",
    data: [
      {
        type: "external",
        title: "Shareholding Pattern 31.12.2024",
        link: "/shareholding-pattern-31-12-2024.html",
      },
      // {
      //   title: "STL Financials June 2023",
      //   link: textilesProspectus,
      // },
      // {
      //   title: "STL Financials June 2022",
      //   link: textilesProspectus,
      // },
      // {
      //   title: "STL Financials June 2021",
      //   link: textilesProspectus,
      // },
    ],
  },
  // {
  //   id: 2,
  //   mainTitle: "Universal Texturisers Private Limited (Subsidiary)",
  //   data: [
  //     {
  //       title: "STL Financials 2024",
  //       link: textilesProspectus,
  //     },
  //     {
  //       title: "STL Financials 2023",
  //       link: textilesProspectus,
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   mainTitle: "Sanathan Polycot Private Limited (Subsidiary)",
  //   data: [
  //     {
  //       title: "STL Financials 2023",
  //       link: textilesProspectus,
  //     },
  //     {
  //       title: "STL Financials 2022",
  //       link: textilesProspectus,
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   mainTitle: "Vajubhai Investments Private Limited (Group Company)",
  //   data: [
  //     {
  //       title: "STL Financials 2022",
  //       link: textilesProspectus,
  //     },
  //     {
  //       title: "STL Financials 2021",
  //       link: textilesProspectus,
  //     },
  //   ],
  // },
];

const shareHoldinData2425 = [
  {
    id: 1,
    mainTitle: "Sanathan Textiles Limited",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials June 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials June 2022",
        link: textilesProspectus,
      },
      {
        title: "STL Financials June 2021",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Universal Texturisers Private Limited (Subsidiary)",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 3,
    mainTitle: "Sanathan Polycot Private Limited (Subsidiary)",
    data: [
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 4,
    mainTitle: "Vajubhai Investments Private Limited (Group Company)",
    data: [
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2021",
        link: textilesProspectus,
      },
    ],
  },
];

const shareHoldinData2324 = [
  {
    id: 1,
    mainTitle: "Sanathan Textiles Limited",
    data: [
      {
        title: "STL Financials June 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials June 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials June 2022",
        link: textilesProspectus,
      },
      {
        title: "STL Financials June 2021",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 2,
    mainTitle: "Universal Texturisers Private Limited (Subsidiary)",
    data: [
      {
        title: "STL Financials 2024",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 3,
    mainTitle: "Sanathan Polycot Private Limited (Subsidiary)",
    data: [
      {
        title: "STL Financials 2023",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
    ],
  },
  {
    id: 4,
    mainTitle: "Vajubhai Investments Private Limited (Group Company)",
    data: [
      {
        title: "STL Financials 2022",
        link: textilesProspectus,
      },
      {
        title: "STL Financials 2021",
        link: textilesProspectus,
      },
    ],
  },
];

const ShareHoldinDataList = ({ listData, width }) => {
  return (
    <>
      {listData.map((item, i) => (
        <div className="data_list_box" key={i}>
          <div className="head_wrapper">
            <h3 className="title">{item.mainTitle}</h3>
            <img src={investUpArrow} alt="arrow" className="arrow" />
          </div>

          <div className="content_wrapper">
            {item?.data?.map((data, index) => (
              <div className="pdf_container" key={index}>
                <div className={`pdf_text_wrapper`}>
                  <img
                    src={investPdfIcon}
                    alt="pdf icon"
                    className="pdf_icon"
                  />
                  <h4 className="pdf_title">{data.title}</h4>
                </div>
                {width > 767 ? (
                  <a href={data.link} download className="pdf_link">
                    Download
                  </a>
                ) : (
                  <a href={data.link} download className={`pdf_link`}>
                    <img
                      src={investDwnIcon}
                      alt="download"
                      className="dwn_icon"
                    />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

const ShareholdingPattern = () => {
  const { width } = useWindowDimensions();
  const location = useLocation();
  const history = useHistory();
 const [activeKey, setActiveKey] = useState("acc-0");

  const tabListBottom = tabBottomData.map((tab, i) => (
    <NavLink
      className="tab_name"
      activeClassName="active"
      exact
      to={tab.link}
      key={`tab-${i}`}
    >
      <span className="tab_text">{tab.title}</span>
    </NavLink>
  ));

  const tabListTop = tabTopData.map((tab, i) => (
    <NavLink
      className="tab_name"
      activeClassName="active"
      exact
      to={tab.link}
      key={`tab-${i}`}
    >
      <span className="tab_text">{tab.title}</span>
    </NavLink>
  ));

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        setTimeout(() => {
          const offset = 100; // Gap from viewport top
          const targetPosition =
            targetSection.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: targetPosition, behavior: "smooth" });
          // targetSection.scrollIntoView({ behavior: "smooth" });
        }, 0);
        // history.replace("/investor-relations/investor-meet-presentation");
        history.replace(location.pathname);
      }
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Sanathan Investor Relations | Shareholding Pattern Details"
        metaDesc="Explore the shareholding pattern of Sanathan Textiles. Stay updated with investor relations, shareholder insights, and key ownership details. Visit us for more information."
      />

      <section className="share_hold_sec1 investor_relations">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} Investor Relations
          </div>
          <div className="left_section">
            <h2 className="hollow_title">Investor Relations</h2>
            <div className="dash_wrapper">
              <Dash />
            </div>
            {/* <h3></h3> */}
            {/* <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </p> */}
          </div>
          <div className="right_section">
            <figure className="bg_img">
              <img src={InvestorBgImg} alt="sanathan img" />
            </figure>
            <figure className="fg_img">
              <img src={InvestorFgImg} alt="sanathan img" />
            </figure>
            <div className="box_stock_hold">
              {width >= 769 && <Stock />}
            </div>
          </div>
          {/* mobile section for image*/}
          <div className="mobile_section">
            <figure className="mob_bg_img">
              <img
                className="mob_img1"
                src={InvestorBgImg}
                alt="sanathan img"
              />
            </figure>
            <figure className="mob_fg_img">
              <img src={InvestorFgImg} alt="sanathan img" />
            </figure>
          </div>
        </div>
      </section>
      <section className="stockWrapper stck_ivstor_rel">
        <div className="wrapper">{width <= 768 && <Stock />}</div>
      </section>
      <section className="share_hold_sec2" id="shareholding">
        <div className="wrapper">
          <div className="row invest_row">
            <div className="col-md-4 invest_col">
              {width > 767 ? (
                <InvestTab />
              ) : (
                <div className="invest_tab_wrapper">{tabListTop}</div>
              )}
            </div>
            <div className="col-md-8 invest_col">
              <h1 className="heading">Shareholding Pattern</h1>
              <div className="data_list_container">
                <div className="data_col">
                  <h3 className="year">2024 - 2025</h3>
                  {/* <ShareHoldinDataList
                    listData={shareHoldinData2425}
                    width={width}
                  /> */}
                  <FinanceAcc
                    accData={intimationOfInvestorMeetData}
                    dwnIcon={width > 767 ? false : true}
                    activeKey={activeKey}
                    setActiveKey={setActiveKey}
                    columnKey="acc"
                  />
                </div>
                {/* <div className="data_col">
                  <h3 className="year">2023 - 2024</h3>
                    <FinanceAcc
                    accData={intimationOfInvestorMeetData}
                    dwnIcon={width > 767 ? false : true}
                    activeKey={activeKey}
                    setActiveKey={setActiveKey}
                    columnKey="acc"
                  />
                </div> */}
              </div>

              {width <= 767 && (
                <div className="invest_tab_wrapper invest_tab_wrapper_2">
                  {tabListBottom}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ShareholdingPattern;
